var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 23 13",
    style: {
      enableBackground: "new 0 0 23 13"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t    .list-icon-st0{fill:currentColor;}\n    ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "list-icon-st0",
    d: "M22.375 2.87492H5.45833V0.458252H22.375V2.87492ZM22.375 7.70825H5.45833V5.29158H22.375V7.70825ZM22.375 12.5416H5.45833V10.1249H22.375V12.5416ZM3.04167 12.5416H0.625V10.1249H3.04167V12.5416ZM3.04167 0.458252V2.87492H0.625V0.458252H3.04167ZM3.04167 7.70825H0.625V5.29158H3.04167V7.70825Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListViewIcon);
export default __webpack_public_path__ + "static/media/list-view-icon.388b6dd991cbd5d724469000ed14146b.svg";
export { ForwardRef as ReactComponent };